<div class="auth-shell">
  <div class="auth-card">
    <section class="brand-panel">
      <div class="brand-mark">
        <span class="brand-logo" aria-hidden="true">
          <img [src]="brand.logoPath" alt="" />
        </span>
        <span class="brand-name">{{ brand.name }}</span>
      </div>
      <h1>Reset your access in minutes</h1>
      <p>
        Enter the mobile number linked to your account and we will send a verification
        code to reset your password.
      </p>
      <div class="feature-list">
        <div class="feature">
          <mat-icon>sms</mat-icon>
          <span>Instant SMS verification</span>
        </div>
        <div class="feature">
          <mat-icon>verified_user</mat-icon>
          <span>Secure identity checks</span>
        </div>
        <div class="feature">
          <mat-icon>support_agent</mat-icon>
          <span>Help when you need it</span>
        </div>
      </div>
    </section>

    <section class="form-panel">
      <mat-card class="form-card">
        <mat-card-header>
          <mat-card-title>Forgot password</mat-card-title>
          <mat-card-subtitle>We will text you a one-time reset code.</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <form class="form-grid" [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
            <div class="phone-row">
              <mat-form-field appearance="outline" class="country-code">
                <mat-label>Country</mat-label>
                <mat-select formControlName="countryCode">
                  <mat-option value="+1">
                    <span class="country-option">
                      <span class="flag flag-us" aria-hidden="true"></span>
                      <span>US +1</span>
                    </span>
                  </mat-option>
                  <mat-option value="+44">
                    <span class="country-option">
                      <span class="flag flag-uk" aria-hidden="true"></span>
                      <span>UK +44</span>
                    </span>
                  </mat-option>
                  <mat-option value="+61">
                    <span class="country-option">
                      <span class="flag flag-au" aria-hidden="true"></span>
                      <span>AU +61</span>
                    </span>
                  </mat-option>
                  <mat-option value="+65">
                    <span class="country-option">
                      <span class="flag flag-sg" aria-hidden="true"></span>
                      <span>SG +65</span>
                    </span>
                  </mat-option>
                  <mat-option value="+91">
                    <span class="country-option">
                      <span class="flag flag-in" aria-hidden="true"></span>
                      <span>IN +91</span>
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Phone number</mat-label>
                <input matInput formControlName="phone" placeholder="9876543210" />
                <mat-hint>10 digits only</mat-hint>
                <mat-error *ngIf="forgotForm.get('phone')?.hasError('required')">
                  Phone number is required.
                </mat-error>
                <mat-error *ngIf="forgotForm.get('phone')?.hasError('pattern')">
                  Please enter a valid phone number.
                </mat-error>
              </mat-form-field>
            </div>

            @if(validationError()){
            <app-validation-error [errors]="validationError()"></app-validation-error>
            }

            <div class="form-actions">
              <button mat-raised-button color="primary" type="submit">Send reset code</button>
              <button mat-button type="button" routerLink="/auth/login">Back to login</button>
            </div>
          </form>
          <mat-divider class="section-divider"></mat-divider>
          <!-- <div class="footer-actions">
            <span>Need an account?</span>
            <button mat-button type="button" routerLink="/auth/register">Create account</button>
          </div> -->
        </mat-card-content>
      </mat-card>
    </section>
  </div>
</div>
